import React, { useState } from 'react';
import './HomePage.css';
import organizationsData from '../data/organizations.json';
import ToptalBadge from './ToptalBadge';

interface OrganizationIcon {
    id: string;
    name: string;
    imageSrc: string;
    alt: string;
    width: number;
    height: number;
    webpage: string;
    start: string;
    end: string;
    location: string;
    type: string;
    experience: {
        description: string;
        technologies: string[];
    }[];
}

const HomePage: React.FC = () => {
    const [hoveredIcon, setHoveredIcon] = useState<string | null>(null);

    // Helper function to format MM.YYYY to "Mon Year" format
    const formatDate = (dateString: string): string => {
        if (dateString === 'Present') return 'Present';
        
        const [month, year] = dateString.split('.');
        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        
        const monthIndex = parseInt(month) - 1;
        return `${monthNames[monthIndex]} ${year}`;
    };

    // Load organizations data from JSON file and add process.env.PUBLIC_URL to image paths
    const organizations: OrganizationIcon[] = organizationsData.map(org => ({
        ...org,
        imageSrc: `${process.env.PUBLIC_URL}${org.imageSrc}`
    }));

    const renderTooltipContent = () => {
        if (!hoveredIcon) return null;

        const organization = organizations.find(org => org.id === hoveredIcon);
        if (!organization) return null;

        return (
            <div key={organization.id} className='full-width-tooltip'>
                <div>
                    <div className='tooltip-title'>
                        {organization.name}
                    </div>
                    <div className='tooltip-meta'>
                        <span className='meta-start'>🕒 {formatDate(organization.start)} - {formatDate(organization.end)}</span>
                        <span className='meta-center'>🏠 {organization.location}</span>
                        <span className='meta-end'>👤 {organization.type}</span>
                    </div>
                </div>
                {organization.experience.map((item, index) => (
                    <div key={index} className='tooltip-line'>
                        <div>{item.description}</div>
                        {item.technologies.length > 0 && (
                            <div className='tooltip-technologies'>
                                {item.technologies.join(', ')}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className='home-page'>
            <div className='toptal-badge-wrapper'>
                <ToptalBadge />
            </div>
            <div className='text-container'>
                <h1>Emre Tapcı</h1>
                <h2>Software Engineer | Architect | System Designer</h2>
                <h2>Full Stack | NodeJS & ReactJS | C# & ASP.NET core | Java & Spring | Python, Django</h2>
                <h2>Agentic AI | LangChain | LangGraph | ChromaDB | RAG | PyTorch</h2>
                <h2>Docker | Kubernetes | AWS | Terraform</h2>
            </div>
            <div className='images-container'>
                <div className='icons-wrapper'>
                    {organizations.map((org) => (
                        <div
                            key={org.id}
                            className='icon-wrapper'
                            onMouseEnter={() => setHoveredIcon(org.id)}
                        >
                            <a href={org.webpage} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={org.imageSrc}
                                    alt={org.alt}
                                    width={org.width}
                                    height={org.height}
                                />
                            </a>
                        </div>
                    ))}
                </div>
                {renderTooltipContent()}
            </div>
        </div>
    );
};

export default HomePage;
